import { colors } from 'components/styles/variables';
import PropTypes from 'prop-types';

const Action = ({ children, className = '' }) => {
  return (
    <span className={`action ${className}`}>
      {children}
      <style jsx>{`
        .action {
          font-size: 16px;
          font-weight: 600;
          color: ${colors.ALB1};
          text-transform: uppercase;
        }

        .action:hover {
          color: ${colors.ALB2};
        }
      `}</style>
    </span>
  );
};

Action.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Action;
